module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Moviles-4.182cc0c1.png";